/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as AppPropTypes from '../../lib/PropTypes';

import FilterButtons from '../partials/FilterButtons';
import ProjectTile from '../items/ProjectTile';
import { getComponentFromName } from '../../lib/utils';

import styles from '../../../styles/lists/grid-with-filters.module.scss';

const propTypes = {
    items: PropTypes.arrayOf(AppPropTypes.project),
    filters: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            label: PropTypes.string,
            selected: PropTypes.bool,
        }),
    ),
    query: PropTypes.shape(),
    onQueryChange: PropTypes.func,
    components: PropTypes.objectOf(PropTypes.func),
    withoutFilters: PropTypes.bool,
    className: PropTypes.string,
    itemClassName: PropTypes.string,
};

const defaultProps = {
    items: null,
    filters: null,
    query: null,
    onQueryChange: null,
    components: {
        project: ProjectTile,
    },
    withoutFilters: false,
    className: null,
    itemClassName: null,
};

const GridWithFilters = ({
    items,
    filters,
    query,
    onQueryChange,
    components,
    withoutFilters,
    className,
    itemClassName,
}) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
    >
        {!withoutFilters ? (
            <div className={styles.filters}>
                {(filters || []).map((filter, filterIndex) => (
                    <FilterButtons
                        key={`filter-${filterIndex + 1}`}
                        filter={filter}
                        value={query}
                        onChange={onQueryChange}
                    />
                ))}
            </div>
        ) : null}
        <div className={styles.grid}>
            {items !== null &&
                items.map((item, index) => {
                    const { id = null, pageType = null, url = null } = item || {};
                    const Component = getComponentFromName(components, pageType);
                    return Component !== null ? (
                        <div
                            key={`item-${id}-${index + 1}-${url}`}
                            className={classNames([
                                styles.item,
                                { [itemClassName]: itemClassName !== null },
                            ])}
                        >
                            <Component item={item} index={index} withoutButtonLabel />
                        </div>
                    ) : null;
                })}
        </div>
    </div>
);

GridWithFilters.propTypes = propTypes;
GridWithFilters.defaultProps = defaultProps;

export default GridWithFilters;
